import * as rc from './resultCodes'

const module = {
  namespaced: true,
  state: {
    message: {
      [rc.ok]: 'ok',
      [rc.syntaxError]: 'Syntax Error',
      [rc.invalidSession]: 'Invalid Session',
      [rc.unknownRequest]: 'unknow message',
      [rc.alreadyLoggedIn]: 'Already LoggedIn',
      [rc.notLoggedIn]: 'User not loggedIn',
      [rc.authError]: 'Authentification failed',
      [rc.permissionDenied]: 'Co-signer permission denied',
      [rc.unknownUser]: 'User e-mail not exist',
      [rc.noContractWithSelf]: 'Invalid co-signer email',
      [rc.errorMailUrl]: 'Error mailing server',
      [rc.alreadyExistEmailUser]: 'email already exist',
      [rc.alreadyExistLoginUser]: 'login already exist',
      [rc.wrongUserStatus]: 'Wrong user status',
      [rc.userAlreadyActif]: 'User already actif',
      [rc.wrongContractActivationCode]: 'Invalid contract activation code',
      [rc.sendMailOK]: 'sendMail OK',
      [rc.missingField]: 'Technical Error',
      [rc.notContractFound]: 'Contract not found',
      [rc.wrongUserParty]: 'Invalid counter party',
      [rc.errorDatabase]: 'Technical Error',
      [rc.projectActive]: 'Project Actif',
      [rc.existContractActive]: 'invalid contract status',
      [rc.errorNotAllUserJoined]: 'not all cosigners joined',
      [rc.errorWrongContractStatus]: 'wrong contract status',
      [rc.needToChangePassword]: 'Need to change password',
      [rc.sendBLCcreateAccount]: 'Error sending to BL for create account',
      [rc.sendBLCdeployContract]: 'Error sending to BL for deploy contract',
      [rc.errorBLCcreateAccount]: 'Error BL for create account',
      [rc.errorBLCdeployContract]: 'Error BL for deploy contract',
      [rc.missingUserPassphrase]: 'Missing user passphrase',
      [rc.permissionError]: 'Permission denied',
      [rc.invalidKeys]: 'Invalid SSH key',
      [rc.keyNotFound]: 'SSH key not found',
      [rc.verifyKeyError]: 'verify sign key error',
      [rc.keyIdNotMatch]: 'KeyId not matching',
      [rc.keyAlreadyExists]: 'Key already exists'
    }
  },
  getters: {
    resultMessage: state => state.message
  },
  mutations: {
  },
  actions: {
  }
}

export default module
